// extracted by mini-css-extract-plugin
export default {"content":"tFunaD","button":"Y3DZRM","mobile":"vkdFMp"};